import React from 'react';
import { useAppStore } from '../../../../store/useAppStore';
import AssetPicker from '../../../Assets/AssetPicker';

export const AvatarForm = ({ component, onUpdate }) => {
  const { appName } = useAppStore();

  const handleChange = (field, value) => {
    onUpdate(component.id, {
      specificAttrs: { ...component.specificAttrs, [field]: value }
    });
  };

  const { specificAttrs } = component;

  return (
    <div style={{ display: 'grid', gap: '12px' }}>
      {/* Asset Picker for avatar image */}
      {appName && (
        <AssetPicker
          appId={appName}
          value={specificAttrs.src || ''}
          onChange={(url) => handleChange('src', url)}
          label="Avatar Image"
          fileType="image"
          placeholder="Select an avatar image..."
          showPreview={true}
        />
      )}
      
      {/* Manual URL Input (fallback) */}
      <div>
        <label style={{ fontSize: '12px', fontWeight: '500', color: '#4B5563', display: 'block', marginBottom: '4px' }}>
          Or Enter Image URL Manually
        </label>
        <input
          type="text"
          value={specificAttrs.src || ''}
          onChange={(e) => handleChange('src', e.target.value)}
          placeholder="https://example.com/avatar.jpg"
          style={{
            width: '100%',
            padding: '6px 10px',
            fontSize: '13px',
            border: '1px solid #D1D5DB',
            borderRadius: '6px'
          }}
        />
      </div>

      {/* Alt Text */}
      <div>
        <label style={{ display: 'block', fontSize: '12px', fontWeight: '500', marginBottom: '4px', color: '#4B5563' }}>
          Alt Text
        </label>
        <input
          type="text"
          value={specificAttrs.alt || ''}
          onChange={(e) => handleChange('alt', e.target.value)}
          placeholder="User avatar"
          style={{
            width: '100%',
            padding: '6px 10px',
            fontSize: '13px',
            border: '1px solid #D1D5DB',
            borderRadius: '6px'
          }}
        />
      </div>

      {/* Avatar Options */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
        {/* Size */}
        <div>
          <label style={{ display: 'block', fontSize: '12px', fontWeight: '500', marginBottom: '4px', color: '#4B5563' }}>
            Size
          </label>
          <select
            value={specificAttrs.size || 'medium'}
            onChange={(e) => handleChange('size', e.target.value)}
            style={{
              width: '100%',
              padding: '6px 10px',
              fontSize: '13px',
              border: '1px solid #D1D5DB',
              borderRadius: '6px',
              backgroundColor: 'white',
              cursor: 'pointer'
            }}
          >
            <option value="small">Small (32px)</option>
            <option value="medium">Medium (48px)</option>
            <option value="large">Large (64px)</option>
            <option value="xlarge">Extra Large (96px)</option>
          </select>
        </div>

        {/* Shape */}
        <div>
          <label style={{ display: 'block', fontSize: '12px', fontWeight: '500', marginBottom: '4px', color: '#4B5563' }}>
            Shape
          </label>
          <select
            value={specificAttrs.shape || 'circle'}
            onChange={(e) => handleChange('shape', e.target.value)}
            style={{
              width: '100%',
              padding: '6px 10px',
              fontSize: '13px',
              border: '1px solid #D1D5DB',
              borderRadius: '6px',
              backgroundColor: 'white',
              cursor: 'pointer'
            }}
          >
            <option value="circle">Circle</option>
            <option value="square">Square</option>
            <option value="rounded">Rounded Square</option>
          </select>
        </div>
      </div>

      {/* Border Options */}
      <div style={{ borderTop: '1px solid #E5E7EB', paddingTop: '12px' }}>
        <label style={{ fontSize: '12px', fontWeight: '600', color: '#374151', display: 'block', marginBottom: '8px' }}>
          Border & Effects
        </label>

        <div style={{ display: 'grid', gap: '8px' }}>
          {/* Show Border */}
          <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
            <input
              type="checkbox"
              checked={specificAttrs.showBorder !== false}
              onChange={(e) => handleChange('showBorder', e.target.checked)}
              style={{ width: '16px', height: '16px', cursor: 'pointer' }}
            />
            <span style={{ fontSize: '12px', fontWeight: '500', color: '#4B5563' }}>
              Show Border
            </span>
          </label>

          {/* Border Color */}
          {specificAttrs.showBorder !== false && (
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginTop: '4px' }}>
              <div>
                <label style={{ display: 'block', fontSize: '11px', fontWeight: '500', marginBottom: '4px', color: '#6B7280' }}>
                  Border Color
                </label>
                <input
                  type="color"
                  value={specificAttrs.borderColor || '#E5E7EB'}
                  onChange={(e) => handleChange('borderColor', e.target.value)}
                  style={{
                    width: '100%',
                    height: '32px',
                    border: '1px solid #D1D5DB',
                    borderRadius: '6px',
                    cursor: 'pointer'
                  }}
                />
              </div>

              <div>
                <label style={{ display: 'block', fontSize: '11px', fontWeight: '500', marginBottom: '4px', color: '#6B7280' }}>
                  Border Width (px)
                </label>
                <input
                  type="number"
                  value={specificAttrs.borderWidth || 2}
                  onChange={(e) => handleChange('borderWidth', parseInt(e.target.value) || 2)}
                  min="1"
                  max="10"
                  style={{
                    width: '100%',
                    padding: '6px 10px',
                    fontSize: '13px',
                    border: '1px solid #D1D5DB',
                    borderRadius: '6px'
                  }}
                />
              </div>
            </div>
          )}

          {/* Shadow */}
          <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
            <input
              type="checkbox"
              checked={specificAttrs.showShadow || false}
              onChange={(e) => handleChange('showShadow', e.target.checked)}
              style={{ width: '16px', height: '16px', cursor: 'pointer' }}
            />
            <span style={{ fontSize: '12px', fontWeight: '500', color: '#4B5563' }}>
              Add Shadow Effect
            </span>
          </label>
        </div>
      </div>

      {/* Preview Info */}
      <div style={{
        padding: '10px',
        backgroundColor: '#F0F9FF',
        border: '1px solid #BFDBFE',
        borderRadius: '6px',
        fontSize: '11px',
        color: '#1E40AF'
      }}>
        <strong>Preview:</strong> Avatar will display as {specificAttrs.shape || 'circle'} shape with {specificAttrs.size || 'medium'} size.
      </div>
    </div>
  );
};



